<template>
  <div class="app-container">
    <div class="global-header-wrap">
      <span v-if="!$route.query.id">{{ $t('commonMsg.new') }}</span>
      <span v-else>{{ $t('commonMsg.edit') }}</span>
      <div>
        <button class="global-button-style" @click="$router.back()">
          {{ $t('commonMsg.back') }}
        </button>
        <button class="global-button-style" @click="submitForm('ruleForm')">
          {{ $t('commonMsg.save') }}
        </button>
      </div>
    </div>
    <el-card
      class="app-table-container"
      :body-style="{ padding: '20px 0 20px 20px' }"
    >
      <div class="" v-bar>
        <div class="body-wrap">
          <el-form
            label-width="120px"
            :model="form"
            @submit.native.prevent
            ref="ruleForm"
            :rules="rules"
          >
            <el-form-item label="KEY" prop="key">
              <el-input v-model="form.key" style="width: 200px"></el-input>
            </el-form-item>
            <el-form-item label="类型" prop="type">
              <el-select
                v-model="form.type"
                :placeholder="$t('placeholder.select')"
                value-key="value"
                clearable
                filterable
              >
                <el-option
                  v-for="item in configType"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="数据类型" prop="dataType">
              <el-select
                v-model="form.dataType"
                :placeholder="$t('placeholder.select')"
                value-key="value"
                clearable
                filterable
              >
                <el-option
                  v-for="item in configDataType"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="数据" prop="data">
              <el-input placeholder="请输入内容" v-model="form.data" />
            </el-form-item>
            <el-form-item label="描述" prop="desc">
              <el-input
                type="textarea"
                :rows="4"
                placeholder="请输入内容"
                :autosize="{ minRows: 4, maxRows: 8 }"
                v-model="form.desc"
              />
            </el-form-item>
          </el-form>
        </div>
      </div>
    </el-card>
  </div>
</template>

<script>
export default {
  computed: {},
  components: {},
  data() {
    return {
      configDataType: [],
      configType: [],
      form: {
        key: '',
        dataType: '',
        type: '',
        data: '',
        desc: ''
      },
      rules: {
        key: [
          {
            required: true,
            message: '内容不能为空',
            trigger: 'blur'
          }
        ],
        dataType: [
          {
            required: true,
            message: '内容不能为空',
            trigger: 'blur'
          }
        ],
        type: [
          {
            required: true,
            message: '内容不能为空',
            trigger: 'blur'
          }
        ],
        data: [
          {
            required: true,
            message: '内容不能为空',
            trigger: 'blur'
          }
        ],
        desc: [
          {
            required: true,
            message: '内容不能为空',
            trigger: 'blur'
          }
        ]
      }
    }
  },
  methods: {
    async init() {
      await this.getAdminConfigDataTypeList()
      await this.getAdminConfigTypeList()
      if (!this.$route.query.id) return
      this.getDetails()
    },

    async getAdminConfigDataTypeList() {
      try {
        let res = await this.$http.getAdminConfigDataTypeList({
          pageSize: 1000,
          page: 1
        })
        this.configDataType = res.data.rows
        return this.configDataType
      } catch (error) {}
    },
    async getAdminConfigTypeList() {
      try {
        let res = await this.$http.getAdminConfigTypeList({
          pageSize: 1000,
          page: 1
        })
        this.configType = res.data.rows
        return this.configType
      } catch (error) {}
    },

    async getDetails() {
      let res = await this.$http.getAdminConfigDetails(this.$route.query.id)
      this.form = Object.assign(this.form, res.data)
      this.form.data = res.data.data.value
      this.form.dataType = res.data.data.dataType
    },

    submitForm(formName) {
      this.$refs[formName].validate(async (valid) => {
        if (valid) {
          if (this.$route.query.id) {
            this.edit()
          } else {
            this.create()
          }
        } else {
          return false
        }
      })
    },

    async create() {
      await this.$http.createAdminConfig(this.form)
      this.elMsg(this.$t('alertMsg.saveSuccess'), 'success')
      this.$router.push({
        name: 'adminConfig'
      })
    },

    async edit() {
      await this.$http.updateAdminConfig(this.$route.query.id, this.form)
      this.elMsg(this.$t('alertMsg.saveSuccess'), 'success')
      this.$router.push({
        name: 'adminConfig'
      })
    }
  },
  mounted() {
    this.init()
  }
}
</script>

<style lang="scss">
.body-wrap {
  /* height: 100%; */
  flex: 1;
  overflow: hidden;
  .el-form {
    padding: 0 60px;
    .global-button-style {
      width: 100%;
      margin: 0;
    }
  }
}
</style>
